<div class="container">
  <div class="row mt-3 mb-3">
    <div class="col">
      <div class="card">
        <form [formGroup]="companyFormGroup" (ngSubmit)="onCompanyFormSubmit()">
          <div class="card-header">
            Company
          </div>
          <div class="card-body">
            <dl class="row">
              <dt class="col-sm-3 text-right align-middle">
                <label class="control-label col-form-label-sm">Company Name *</label>
              </dt>
              <dd class="col-sm-8">
                <input type="input" class="form-control form-control-sm"
                  [ngClass]="{'is-invalid': companyNameRequireError}" formControlName="name" />
                <div class="invalid-feedback" *ngIf="companyNameRequireError">
                  This field is required.
                </div>
              </dd>
            </dl>
            <hr />
            <dl class="row">
              <dt class="col-sm-3 text-right align-middle">
                <label class="control-label col-form-label-sm">first email *</label>
              </dt>
              <dd class="col-sm-3">
                <input type="input" class="form-control form-control-sm"
                  [ngClass]="{'is-invalid': firstEmailRequireError}" formControlName="firstEmail" />
                <div class="invalid-feedback" *ngIf="firstEmailRequireError">
                  This field is required.
                </div>
              </dd>
              <dt class="col-sm-2 text-right align-middle">
                <label class="control-label col-form-label-sm">second email</label>
              </dt>
              <dd class="col-sm-3">
                <input type="input" class="form-control form-control-sm" formControlName="secondEmail" />
              </dd>
            </dl>
            <dl class="row">
              <dt class="col-sm-3 text-right align-middle">
                <label class="control-label col-form-label-sm">first phone</label>
              </dt>
              <dd class="col-sm-3">
                <input type="input" class="form-control form-control-sm" formControlName="firstPhone" />
              </dd>
              <dt class="col-sm-2 text-right align-middle">
                <label class="control-label col-form-label-sm">second phone</label>
              </dt>
              <dd class="col-sm-3">
                <input type="input" class="form-control form-control-sm" formControlName="secondPhone" />
              </dd>
            </dl>
            <dl class="row">
              <dt class="col-sm-3 text-right align-middle">
                <label class="control-label col-form-label-sm">vat</label>
              </dt>
              <dd class="col-sm-3">
                <input type="input" class="form-control form-control-sm" formControlName="vat" />
              </dd>
              <dt class="col-sm-2 text-right align-middle">
                <label class="control-label col-form-label-sm">fiscal code</label>
              </dt>
              <dd class="col-sm-3">
                <input type="input" class="form-control form-control-sm" formControlName="fiscalCode" />
              </dd>
            </dl>
            <dl class="row">
              <dt class="col-sm-3 text-right align-middle">
                <label class="control-label col-form-label-sm">pec email</label>
              </dt>
              <dd class="col-sm-3">
                <input type="input" class="form-control form-control-sm" formControlName="pecEmail" />
              </dd>
              <dt class="col-sm-2 text-right align-middle">
                <label class="control-label col-form-label-sm">isd number</label>
              </dt>
              <dd class="col-sm-3">
                <input type="input" class="form-control form-control-sm" formControlName="isdNumber" />
              </dd>
            </dl>
            <hr />
            <dl class="row">
              <dt class="col-sm-3 text-right align-middle">
                <label class="control-label col-form-label-sm">address</label>
              </dt>
              <dd class="col-sm-8">
                <input type="input" class="form-control form-control-sm" formControlName="address" />
              </dd>
            </dl>
            <dl class="row" style="justify-content: space-evenly;">
                <app-select-location-group *ngIf="dataFetched"
                  [initialCountry]="chosenCountry"
                  [initialVillage]="chosenVillage"
                  (onVillageChosen)="chosenVillage = $event"
                  (onCountryChosen)="chosenCountry = $event">
                </app-select-location-group>
            </dl>
            <dl class="row">
              <dt class="col-sm-2 text-right align-middle">
                <label class="control-label col-form-label-sm">postal code</label>
              </dt>
              <dd class="col-sm-3">
                <input type="input" class="form-control form-control-sm" formControlName="postalCode" />
              </dd>
            </dl>
            <hr />
            <dl class="row">
              <dt class="col-sm-3 text-right align-middle">
                <label class="control-label col-form-label-sm">status</label>
              </dt>
              <dd class="col-sm-3">
                <select class="form-control form-control-sm" formControlName="status">
                  <option *ngFor="let status of companyStatusArray" [value]="status.value">{{status.label}}</option>
                </select>
              </dd>
            </dl>
            <dl class="row">
              <dt class="col-sm-3 text-right align-middle">
                <label class="control-label col-form-label-sm">Notes</label>
              </dt>
              <dd class="col-sm-8">
                <textarea class="form-control form-control-sm" formControlName="notes" rows="10"></textarea>
              </dd>
            </dl>
          </div>
          <div class="card-footer">
            <a class="btn btn-default btn-sm" href="/companies/details/{{companyId}}">
              <i class="fa fa-times"></i> <br />
              Cancel
            </a>
            <button class="btn btn-primary btn-sm float-right" type="submit">
              <i class="fa fa-save"></i> <br />
              Save
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>
</div>
